import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CompleteInvoiceRequest {
  invoiceIds?: any[];
}

export interface CompleteApiResponseData {
  processedIds: number[];
  unProcessed:
    | {
        id: number;
        errorMessage: string;
      }[]
    | [];
}

const useCompleteInvoiceApi = () => {
  const call = useCallback(async (params?: CompleteInvoiceRequest | undefined) => {
    try {
      if (isEmpty(params?.invoiceIds)) {
        throw new Error('invoiceIds empty');
      }
      const res = await axiosInstance.post(api.completeInvoice, params?.invoiceIds || []);
      return res.data as CompleteApiResponseData;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute, status } = useAsync<CompleteApiResponseData, CompleteInvoiceRequest>(
    call,
    false
  );

  return { completeInvoice: execute, completeCallLoading: isLoading, status };
};

export default useCompleteInvoiceApi;
